<template lang="html">
  <div class="">
    <TimePicker
      v-bind="$attrs"
      v-on="$listeners"
      :defaultValue="defaultValue"
      :format="format"
      :value="attrValue"
      @change="handleValueChange"
    />
  </div>
</template>

<script>
import { TimePicker } from "ant-design-vue";
import moment from "moment";

const Format = "HH:mm";

export default {
  data() {
    return {
      format: Format,
      defaultValue: '00:00'
    };
  },
  computed: {
    attrValue() {
      return this.$attrs.value;
    }
  },
  components: {
    TimePicker
  },
  methods: {
    handleValueChange(_value, time) {
      this.$emit("change", time);
    }
  }
};
</script>

<style lang="css" scoped></style>
